import {$, w} from './constants';

w.load(() => {

	$('.slider-edicion').slick({
		autoplay: true,
  		autoplaySpeed: 1000,
    });

});



// WEBPACK FOOTER //
// ./es6/modal.js